export enum DraftReservationTypes {
  DraftReservationTypes_SaveForLater = 0,
  DraftReservationTypes_ApprovalRequired = 1,
  DraftReservationTypes_AllUser = 2,
}
